import type { ReactNode } from 'react'
import './CollapsiblePanel.css'

interface CollapsiblePanelProps {
  title: string
  open: boolean
  onToggle: () => void
  children: ReactNode
}

export function CollapsiblePanel({ title, open, onToggle, children }: CollapsiblePanelProps) {
  return (
    <div className={`collapsible${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className="collapsible-header"
        onClick={onToggle}
        aria-expanded={open}
      >
        <span>{title}</span>
        <span className="collapsible-chevron" aria-hidden>
          {open ? '▾' : '▸'}
        </span>
      </button>
      {open && <div className="collapsible-body">{children}</div>}
    </div>
  )
}
